"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * An implementation of node.js's readline module, it can accept either a Web API ReadableStream or a Node.js
 * ReadableStream. It yields each line in the stream as a string.
 * @param {object} param0
 * @param {Readable} param0.input
 */
async function* createInterface({
  input
}) {
  if (isWebStream(input)) {
    let reader = input.getReader();
    let prevValue = '';
    while (true) {
      // Read value from the reader. Split value by newline. Immediately yield all except the last. Keep the last line in
      // a buffer until next iteration. At the next iteration, prepend the buffer onto the first value. Continue until the
      // stream is done, then yield the last value.
      let {
        done,
        value
      } = await reader.read();
      if (done) {
        if (prevValue.length > 0) {
          yield prevValue;
        }
        break;
      }
      let valueString = typeof value === 'string' ? value : new TextDecoder('utf-8').decode(value);
      let lines = valueString.split('\n');
      lines[0] = prevValue + lines[0];
      for (let i = 0; i < lines.length - 1; i++) {
        yield lines[i];
      }
      prevValue = lines[lines.length - 1];
    }
  } else if (isNodeStream(input)) {
    let prevValue = '';

    // Create a Promise which resolves each time data is received on the stream. Then, reassign `promise` to a new
    // Promise and continue until the stream is done. Buffer and group the data by lines, as above.

    // https://stackoverflow.com/a/59347615/3183051

    let results = [];
    let resolve;
    // This Promise resolves each time we receive a chunk of data, then it is reassigned to a new Promise.
    let promise = new Promise(r => resolve = r);
    let done = false;
    input.on('error', err => {
      throw err;
    }).on('data', chunk => {
      let lines = chunk.toString().split('\n');
      lines[0] = prevValue + lines[0];
      for (let i = 0; i < lines.length - 1; i++) {
        results.push(lines[i]);
      }
      prevValue = lines[lines.length - 1];
      resolve(null);
      // Reassign `promise` to a new Promise
      promise = new Promise(r => resolve = r);
    }).on('end', () => {
      done = true;
      resolve(null);
    });
    while (!done) {
      await promise;
      yield* results;
      results = [];
    }
    if (prevValue.length > 0) {
      yield prevValue;
    }
  } else {
    throw TypeError('input must be a ReadableStream or NodeJS.ReadableStream');
  }
}
function isWebStream(stream) {
  return typeof stream.getReader === 'function';
}
function isNodeStream(stream) {
  return typeof stream.on === 'function';
}
var _default = exports.default = {
  createInterface
};